/** @file applyLocalBatch: runs a command batch on an in-memory document with commands' applyBatch. */
import { applyBatch } from '@zilo/pose3d-commands/apply/applyBatch';
import { makeContext } from '@zilo/pose3d-commands/context/makeContext';
import type { ImageMeta, PuppetDoc } from '../puppetDoc';
import type { Command } from '@zilo/pose3d-commands/types/command';
import type { Reply } from '@zilo/pose3d-commands/types/reply';
import { packShelves } from '@zilo/pose3d-image-io/pack/packShelves';

/** What a local batch yields: the new document (the input when nothing changed) and one reply per command. */
export type LocalBatchResult = { doc: PuppetDoc; replies: Reply[] };

/**
 * Applies `commands` atomically to `doc` as actor `human` at `now` with a seed derived from the revision; `images`
 * are the stored images `slot.fill` may reference. Pure: the input document is never mutated.
 */
export function applyLocalBatch(doc: PuppetDoc, commands: Command[], images: Record<string, ImageMeta>, now: number): LocalBatchResult {
  const batch = { commands, actor: 'human', now, seed: (doc.revision * 2654435761) >>> 0 };
  const result = applyBatch(doc, batch, makeContext(batch, { packShelves, images }));
  return { doc: result.doc, replies: result.reply.replies };
}
